import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Text from "../Text/Text";

const RedStar = ({
  className
}) => /*#__PURE__*/React.createElement(Text, {
  className: className
}, " * ");

RedStar.propTypes = {
  className: PropTypes.string
};
export default styled(RedStar)`
  color: #ec4a41;
  font-size: 14px;
  position: relative;
  top: -1px;
`;